module.exports = __webpack_public_path__ + "img/人才建设.ec1240b4.png";